module.exports = __webpack_public_path__ + "static/media/trigger.edc05230.png";